import styled from 'styled-components';
import {TiHeartFullOutline} from 'react-icons/ti';

export const Tiheart = styled(TiHeartFullOutline)`
  color: #98A8F7;
`